import CourseStudentList from './CourseStudentList';

export default CourseStudentList;